import React from 'react'
import { Form, Field } from 'react-final-form'
import { func } from 'prop-types'
import validate from 'validate.js'
import { Button, InputField, CheckboxField } from '@mc/design-system'
import {
  getCheckboxState,
  NOT_VISIBLE_CHECKED,
  VISIBLE_CHECKED,
} from '@mc/gdpr'
import { useTranslation, Trans } from '@mc/i18n'
import { isGiftAccountClarificationOn } from '../../utils'

const constraints = {
  email: {
    presence: { message: 'Email is required' },
    email: { message: 'Invalid email' },
  },
  password: {
    presence: { message: 'Password is required' },
    length: { minimum: 4, tooShort: 'Password is too short' },
  },
}

const FormFields = (props) => {
  const { onSubmit, onLoginClick } = props

  const { t } = useTranslation('@mc/authentication')
  const emailCapture = getCheckboxState()

  return (
    <Form
      initialValues={{
        gdprOptIn: [NOT_VISIBLE_CHECKED, VISIBLE_CHECKED].includes(
          emailCapture,
        ),
      }}
      onSubmit={onSubmit}
      validate={(values) =>
        validate(values, constraints, { fullMessages: false })
      }
      render={({ handleSubmit, submitting, submitError }) => (
        <form onSubmit={handleSubmit}>
          {!submitting && submitError && (
            <p
              aria-live='assertive'
              className='mc-text--error mc-text--center mc-mb-4'
            >
              {submitError}
            </p>
          )}
          <Field
            component={InputField}
            className='mc-mb-4'
            id='email'
            type='email'
            name='email'
            label='Email'
            data-ba='email-input'
            autoComplete='email'
            required
          />
          <Field
            data-ba='password-input'
            component={InputField}
            className='mc-mb-4'
            id='password'
            type='password'
            name='password'
            label='Password'
            autoComplete='new-password'
            required
          />
          {emailCapture && emailCapture !== NOT_VISIBLE_CHECKED && (
            <Field
              component={CheckboxField}
              className='mc-mb-4'
              name='gdprOptIn'
              label='Keep me up to date on class events and new releases.'
            />
          )}

          {isGiftAccountClarificationOn() ? (
            <>
              <Trans i18nKey='giftSignUpTerms' ns='@mc/authentication'>
                <p className='mc-text-x-small mc-text--center mc-opacity--muted mc-my-4'>
                  <a
                    className='mc-text--link mc-text--nowrap'
                    href='/privacy'
                  ></a>
                  <a
                    className='mc-text--link mc-text--nowrap'
                    href='/terms'
                  ></a>
                </p>
              </Trans>
            </>
          ) : (
            <>
              <p className='mc-text--center mc-my-4'>
                <Trans i18nKey='registerForm.signIn' ns='@mc/authentication'>
                  <a className='mc-text--link' onClick={onLoginClick} />
                </Trans>
              </p>
              <p className='mc-text-x-small mc-text--center mc-opacity--muted mc-my-4'>
                <Trans i18nKey='registerForm.terms' ns='@mc/authentication'>
                  <span className='mc-text--nowrap'>
                    <br></br>
                    <a
                      className='mc-text--link mc-text--nowrap'
                      href='/privacy'
                    />
                    <a
                      className='mc-text--link mc-text--nowrap'
                      href='/terms'
                    />
                  </span>
                </Trans>
              </p>
            </>
          )}

          <Button
            data-ba='submit-btn'
            type='submit'
            loading={submitting}
            fullWidth
          >
            {isGiftAccountClarificationOn()
              ? t('activateGift')
              : t('createAccount')}
          </Button>
        </form>
      )}
    />
  )
}

FormFields.propTypes = {
  onSubmit: func.isRequired,
  onLoginClick: func.isRequired,
}

export default FormFields
